module.exports = __webpack_public_path__ + "static/img/travel-bottom.1084837a.png";